import { Search, Users, UserX, Trophy } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import "./SlateToolbar.css";

const TOP_LABEL = { pts: "PTS", min: "MIN", reb: "REB", ast: "AST", fg3m: "3PM", pra: "PRA" };

function Toggle({ on, onChange, icon: Icon, label, testId, gold }) {
  return (
    <button type="button" data-testid={testId} aria-pressed={on} className={`st-toggle ${on ? "is-on" : ""} ${gold ? "st-gold" : ""}`} onClick={() => onChange(!on)}>
      <span className="st-dot" /><Icon size={14} />{label}
    </button>
  );
}

export function SlateToolbar({ q, setQ, team, setTeam, teams, startersOnly, setStartersOnly, showOut, setShowOut, outCount, count, espn, top10, setTop10, topKey }) {
  return (
    <div className="st-bar">
      <div className="st-search">
        <Search size={16} />
        <input data-testid="today-search-input" placeholder="Search player" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>
      <Select value={team} onValueChange={setTeam} disabled={top10}>
        <SelectTrigger data-testid="today-team-filter" className="st-select"><SelectValue placeholder="All teams" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All teams</SelectItem>
          {teams.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
        </SelectContent>
      </Select>
      <span className="st-divider" aria-hidden="true" />
      <Toggle testId="today-top10-toggle" gold on={top10} onChange={setTop10} icon={Trophy} label={top10 ? `Top 10 · ${TOP_LABEL[topKey]}` : "Top 10"} />
      <Toggle testId="today-starters-toggle" on={startersOnly} onChange={setStartersOnly} icon={Users} label="Starters" />
      <Toggle testId="today-show-out-toggle" on={showOut} onChange={setShowOut} icon={UserX} label={`Show OUT${outCount ? ` (${outCount})` : ""}`} />
      <span className="st-count" data-testid="today-row-count" title={espn ? "Rosters from ESPN" : "Rosters from each team's last game"}>
        <i className={espn ? "is-live" : ""} /><b>{count}</b> players
      </span>
    </div>
  );
}
